import { IProductDetail } from '@/api/types/public';
import Image from '@/components/Image';
import MagicJump, { JumpTarget } from '@/components/MagicJump';
import { setSession } from '@/utils/tools';
import { RightArrowOutlined } from '@zeelool/icon';

interface ActivityBannerProps {
  item: NonNullable<IProductDetail['commodity_details_label']>[0];
  SDProductDetailsPageBtnClick?: (btnName: string) => void;
}

const ActivityBanner: React.FC<ActivityBannerProps> = ({ item, SDProductDetailsPageBtnClick }) => {
  // 只有 type=activity 且 scene=2 时才渲染
  if (item.type !== 'activity' || item.scene !== 2 || item.status !== 1) {
    return null;
  }

  // 如果没有图片，不渲染
  if (!item.image) {
    return null;
  }

  const jumpTarget: JumpTarget | undefined = item.jump_info;

  const handleJumpClick = () => {
    setSession('zl_goodsListEnterPageScene', '商详页活动标签');
    // 触发埋点
    if (item.button_buried_name) {
      SDProductDetailsPageBtnClick?.(item.button_buried_name);
    } else {
      SDProductDetailsPageBtnClick?.('ActivityBanner');
    }
  };

  return (
    <MagicJump item={jumpTarget} onJumpClick={handleJumpClick} className="cursor-pointer mt-[20px]">
      <div
        className="flex h-[32px] items-center justify-between rounded-[4px] px-4 py-0 box-border"
        style={{
          backgroundColor: item.background_color || '#F5F5F5',
        }}
      >
        {/* 左侧图片 */}
        <div className="flex-shrink-0">
          <Image
            src={item.image}
            alt="Activity"
            width={77}
            height={40}
            className="h-[20px] w-[auto] object-contain"
          />
        </div>

        {/* 中间活动文案 */}
        <div className="relative flex-1 mx-4 text-12 text-gray-800 min-w-0">
          {item.activity && (
            <>
              <p
                className="peer truncate"
                style={{
                  color: item.text_color,
                }}
              >
                {item.activity}
              </p>
              <div className="pointer-events-none absolute bottom-full left-0 z-10 mb-2 hidden max-w-[280px] rounded-[4px] bg-[#4d4d4d] px-3 py-2 text-12 leading-[18px] text-white shadow-[0_2px_8px_rgba(0,0,0,0.15)] whitespace-normal break-words lg:peer-hover:block">
                {item.activity}
                <span className="absolute left-4 top-full h-0 w-0 border-x-[6px] border-t-[6px] border-x-transparent border-t-[#4d4d4d]" />
              </div>
            </>
          )}
        </div>

        {/* 右侧跳转按钮 */}
        <div className="flex h-full flex-shrink-0 items-center">
          {item.button && (
            <>
              <button className="inline-flex h-full items-center justify-center border-0 bg-transparent px-4 py-0 text-12 font-medium leading-[16px] text-[#282828] cursor-pointer">
                {item.button}
              </button>
              <RightArrowOutlined className="text-[#808080] text-[18px]" />
            </>
          )}
        </div>
      </div>
    </MagicJump>
  );
};

export default ActivityBanner;
